import { useSuspenseQuery } from '@tanstack/react-query';
import { getSchedulingOptionsOptions } from '@generated';

export function useGetSchedulingOptions() {
	return useSuspenseQuery({
		...getSchedulingOptionsOptions(),
		staleTime: Infinity,
		gcTime: Infinity
	});
}
